function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2467:68539)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79 30.9083V36.7291L39.5 65.4149L39.483 65.4268L0 36.7291V30.9083L10.9319 22.7363H68.0681L79 30.9083Z",
  fill: "#2C398B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79 30.9083V36.7291L39.5 65.4149V22.7363H68.0681L79 30.9083Z",
  fill: "#2C398B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9707 0V44.9396L39.5185 63.876L39.5 63.864L10.0293 44.9337V0L68.9707 0Z",
  fill: "#D1EAE7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.9707 0V44.9396L39.5185 63.876L39.5 63.864V0L68.9707 0Z",
  fill: "#D1EAE7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79 41.2288V77.0009H0V36.7305L39.483 60.93L39.5185 60.9524L79 41.2288Z",
  fill: "#F15A23"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.9994 36.7305V77.0009H39.4824V60.93L39.5179 60.9524L78.9994 36.7305Z",
  fill: "#F15A23"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.75 26.5C28.75 20.497 33.79 15.625 40 15.625C46.21 15.625 51.25 20.497 51.25 26.5C51.25 32.503 46.21 37.375 40 37.375C33.79 37.375 28.75 32.503 28.75 26.5ZM35.9709 31.8096L40 27.9148L44.0291 31.8096L45.3722 30.5113L41.343 26.6165L45.3722 22.7217L44.0291 21.4234L40 25.3182L35.9709 21.4234L34.6278 22.7217L38.657 26.6165L34.6278 30.5113L35.9709 31.8096Z",
  fill: "#D82E29"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2467:68539"
}, /*#__PURE__*/React.createElement("rect", {
  width: 79,
  height: 77,
  fill: "white"
})));

function SvgMailError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 77,
    viewBox: "0 0 79 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailError);
export default __webpack_public_path__ + "static/media/mail-error.e61a48de.svg";
export { ForwardRef as ReactComponent };